<!-- 合作项目 -->
<template>
    <div class="msgSetting business-page">
        <navLeft  :nav="nav"></navLeft>
        <div class="business-content">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" :key="$route.name"/>
            </keep-alive>
            <router-view  v-if="!$route.meta.keepAlive" />
        </div>
    </div>
</template>
<script>
import navLeft from "@/components/business/navLeft.vue";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    navLeft,
  },
  data() {
    return {
      nav: {},
    };
  },
  computed: {},
  created() {
    this.nav = this.$util.getNode("CoProjects");
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
//修改表格 鼠标悬停时高亮背景颜色的修改
 /deep/ .el-table tbody tr:hover>td { background-color: #dcdee1 !important }
//使用了fixed的表格
 /deep/ .el-table__body .el-table__row.hover-row td{
   background-color: #dcdee1 !important;
}
</style>
